
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`A page banner is always placed on top of the homepage below the site header. It conveys an important message to your audience. People respond positively to visual content. Having a page-wide horizontal image on top of your website is a good way to invite visitors to explore your content.`}</p>
    <h2>{`When to use it`}</h2>
    <p>{`For homepage only. People respond positively to visual content. Having a page-wide horizontal image on top of your website is a good way to invite visitors to explore your content.`}</p>
    <p>{`The image should be`}</p>
    <ul>
      <li parentName="ul">{`relevant`}</li>
      <li parentName="ul">{`high quality`}</li>
      <li parentName="ul">{`emotionally persuasive`}</li>
    </ul>
    <p>{`It is important to also have a "Call to action" button.`}</p>
    <h2>{`When not to use it`}</h2>
    <p>{`When it is not used for homepage.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;